export default "__VITE_ASSET__CDuxt7V0__"